import { render, staticRenderFns } from "./CustomerParticipants.vue?vue&type=template&id=6f4318e8&scoped=true&"
import script from "./CustomerParticipants.vue?vue&type=script&lang=js&"
export * from "./CustomerParticipants.vue?vue&type=script&lang=js&"
import style0 from "./CustomerParticipants.vue?vue&type=style&index=0&id=6f4318e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4318e8",
  null
  
)

export default component.exports